import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function BlogNewsletter() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [email, setEmail] = useState('');
  const { elementRef: newsletterRef } = useScrollAnimation({ threshold: 0.2 });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    try {
      const body = new URLSearchParams({ email });
      const res = await fetch('https://readdy.ai/api/form/d6kq6s94a3uojp5fg160', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="py-20" style={{ background: '#0f0f0f' }}>
      <div ref={newsletterRef} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center scroll-animate-fade-in">
        <div
          className="w-14 h-14 flex items-center justify-center rounded-full mx-auto mb-6"
          style={{ background: 'linear-gradient(135deg, #B8860B, #F5D76E)' }}
        >
          <i className="ri-mail-line text-2xl text-black"></i>
        </div>
        <p className="text-xs font-bold tracking-[0.35em] uppercase mb-3" style={{ color: '#B8860B' }}>
          Free Weekly Insights
        </p>
        <h2 className="text-3xl sm:text-4xl font-extrabold mb-4 text-white leading-tight">
          Get the Best Tips Delivered <br />
          <span style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            Straight to Your Inbox
          </span>
        </h2>
        <p className="text-sm leading-relaxed mb-8 max-w-xl mx-auto" style={{ color: '#aaaaaa' }}>
          Join 2,000+ men getting weekly training tips, nutrition strategies, and mindset shifts from Benny Legacy. No fluff. No spam. Just results.
        </p>

        {status === 'success' ? (
          <div
            className="inline-flex items-center gap-3 px-8 py-4 rounded-xl font-bold text-sm"
            style={{ background: 'rgba(184,134,11,0.15)', border: '1px solid #B8860B', color: '#F5D76E' }}
          >
            <i className="ri-check-double-line text-lg"></i>
            You're in! Check your inbox for a welcome message.
          </div>
        ) : (
          <form
            data-readdy-form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Enter your email address"
              required
              className="flex-1 px-5 py-3.5 rounded-md text-sm outline-none"
              style={{
                background: '#1e1e1e',
                border: '1px solid #333333',
                color: '#ffffff',
              }}
              onFocus={e => (e.currentTarget.style.borderColor = '#B8860B')}
              onBlur={e => (e.currentTarget.style.borderColor = '#333333')}
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-7 py-3.5 rounded-md font-bold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)', color: '#000000' }}
            >
              {status === 'loading' ? 'Subscribing...' : 'Subscribe Free'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-xs" style={{ color: '#C8102E' }}>
            Something went wrong. Please try again.
          </p>
        )}

        <p className="mt-4 text-xs" style={{ color: '#555555' }}>
          Unsubscribe anytime. We respect your privacy.
        </p>
      </div>
    </section>
  );
}